import React from 'react'
import { Grid3x3, TrendingUp, MapPin } from 'lucide-react'

export type MarketViewTab = 'products' | 'tradeoffs' | 'map'

interface ViewToggleProps {
  currentView: MarketViewTab
  onChange: (view: MarketViewTab) => void
}

const ViewToggle: React.FC<ViewToggleProps> = ({ currentView, onChange }) => {
  const views = [
    { id: 'products' as const, label: 'Products', icon: Grid3x3 },
    { id: 'tradeoffs' as const, label: 'Tradeoffs', icon: TrendingUp },
    { id: 'map' as const, label: 'Map', icon: MapPin },
  ]

  return (
    <div className="inline-flex bg-muted rounded-md p-0.5 sm:p-1 gap-0.5 sm:gap-1">
      {views.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onChange(id)}
          className={`px-2 sm:px-4 py-1.5 sm:py-2 rounded-sm text-xs sm:text-sm font-medium transition-colors flex items-center gap-1 sm:gap-2
                     ${currentView === id
                       ? 'bg-background text-foreground shadow-sm'
                       : 'text-muted-foreground hover:text-foreground'}`}
          title={label}
        >
          <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex-shrink-0" />
          <span className="hidden sm:inline">{label}</span>
        </button>
      ))}
    </div>
  )
}

export default ViewToggle
